import { addRest, getValue } from '../../utils/parser-utils';
import { ObjectLine } from 'z3k-parser/parser/utils/object-line';
function scenario2Str(obj_id, obj) {
    const timetable = obj.timetable || {};
    return new ObjectLine(obj.id, obj_id, [
        obj.name,
        obj.links,
        timetable.weekday_register || 0,
        timetable.time || 0,
        obj.setting_register || 0,
        obj.loop_time || 0,
        ...(obj.rest || []),
    ]);
}
function scenarioFromString(id, params) {
    return {
        id: id,
        name: params[0],
        links: params[1],
        timetable: {
            //@ts-ignore
            checked: getValue(params, 2, 0) > 0,
            weekday_register: getValue(params, 2, 0),
            time: getValue(params, 3, 0),
        },
        setting_register: getValue(params, 4, 0),
        loop_time: getValue(params, 5, 0),
        ...addRest(params, 6),
    };
}
export const scenario_parser = {
    toStr: scenario2Str,
    fromStr: scenarioFromString,
};
